import React from 'react';
import PropTypes, {instanceOf} from 'prop-types';
import {LocaleProvider, Popover} from 'antd';
import ui from '../../lang/ui.json';
import s from './Header.css';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import history from '../../history';
import {withCookies, Cookies} from "react-cookie";
import {userTypes} from "../../UserTypes";

class Header extends React.Component {
  static propTypes = {
    locale: PropTypes.objectOf(PropTypes.string).isRequired,
  };

  constructor(props) {
    super(props);
    let config = require('Config');
    this.state = {
      root: config.root,
      username: '',
    }
    this.logout = this.logout.bind(this);
  }

  logout = () => {
    sessionStorage.removeItem('authenticationtoken');
    this.props.cookies.remove("authenticationtoken", { path: "/"});
    this.props.cookies.remove('userType',{path: "/"});
    this.props.cookies.remove('username', {path: "/"});
    this.props.cookies.remove('senders_list', {path: "/"});
    this.props.cookies.remove('default_sender', {path: "/"});
    history.push("/");
  }

  componentDidMount() {
    this.setState({username : sessionStorage.getItem("username")})
  }

  render() {
    return (
      <LocaleProvider locale={ui}>
        <header className={s.header}>
          <Link className={s.logo} to="/">
            <Icon icon="logo"/>
            <span>{this.props.locale.title}</span>
          </Link>
          <div className={s.user}>
            <div className={s.notifications}>2</div>
            <span>{this.props.locale.greetings}</span>
            <Popover placement="bottom" content={<p onClick={this.logout} className={s.logout}
              > Logout </p>}>

              <span className={s.confirm}>
                <span className={s.username}>{this.state.username}</span>
                <div className={s.icon}>
                  <Icon icon="chevron_down"/>
                </div>
              </span>
            </Popover>
          </div>
        </header>
      </LocaleProvider>
    );
  }
}

export default withCookies(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js